<template>
    <!--弹窗-->
    <el-dialog
        v-if="dialogVisible"
        width="1400px"
        :title="pageType ==1 ? '运营asin生成' : pageType ==2 ? '运营asin查看' : '运营asin修改'"
        top="3vh"
        :visible.sync="dialogVisible"
        :before-close="handleClose"

    >
        <el-form ref="formData" :inline="false" class="query-form" size="mini" :rules="rules" :model="formData"
                 :label-position="'right'" label-width="130px">

            <div class="wrapBox">
                <div class="boxItem">
                    <el-form-item label="数据核对：" class="query-form-item">
                    </el-form-item>
                    <el-form-item label="包装核对：" class="query-form-item">
                        <el-select v-model="formData.check_packing" placeholder="包装核对" size="mini">
                            <el-option :label="item.name" :value="item.value" v-for="item in collateArr"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="价格核对：" class="query-form-item">
                        <el-select v-model="formData.check_price" placeholder="价格核对" size="mini">
                            <el-option :label="item.name" :value="item.value" v-for="item in isLowPrice"></el-option>
                        </el-select>
                    </el-form-item>
<!--                    <el-form-item label="vine情况：" class="query-form-item">-->
<!--                        <el-select v-model="formData.vine_status" placeholder="vine情况" size="mini">-->
<!--                            <el-option :label="item.name" :value="item.value" v-for="item in vineStatusArr"></el-option>-->
<!--                        </el-select>-->
<!--                    </el-form-item>-->

<!--                    <el-form-item label="vine店铺：" class="query-form-item">-->
<!--                        <el-input style="width: 150px;" clearable v-model="formData.vine_shop" placeholder="请输入vine店铺"-->
<!--                                  size="mini"></el-input>-->
<!--                    </el-form-item>-->
                    <el-form-item label="备注：" class="query-form-item">
                        <el-input clearable v-model="formData.remark" placeholder="请输入备注" type="textarea" :rows="2"
                                  size="mini" style="width: 220px"></el-input>
                    </el-form-item>

                </div>

                <div class="boxItem">
                    <el-form-item label="广告情况：" class="query-form-item">
                    </el-form-item>
                    <el-form-item label="广告商铺：" class="query-form-item">
                        <el-input style="width: 150px;" clearable v-model="formData.ad_shopname" placeholder="请输入广告商铺"
                                  size="mini" disabled></el-input>
                    </el-form-item>

                    <el-form-item label="广告Asin：" class="query-form-item">
                        <el-input style="width: 150px;" clearable v-model="formData.ad_asin" placeholder="请输入广告Asin"
                                  size="mini" disabled></el-input>
                    </el-form-item>

                    <el-form-item label="广告MSKu：" class="query-form-item">
                        <el-input style="width: 150px;" clearable v-model="formData.ad_msku" placeholder="请输入广告MSKu"
                                  size="mini" disabled></el-input>
                    </el-form-item>

                    <el-form-item label="广告品名：" class="query-form-item">
                        <el-input style="width: 150px;" clearable v-model="formData.ad_product_name"
                                  placeholder="请输入广告品名"
                                  size="mini" disabled></el-input>
                    </el-form-item>

                    <el-button @click="openAdvertisingSituation" type="success" size="mini" style="margin-left: 100px">
                        更改
                    </el-button>

                    <el-form-item label="是否主卖：" class="query-form-item">
                        <el-radio-group v-model="formData.is_main_seller">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-form-item>

                </div>

            </div>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose" type="primary" size="mini">关 闭</el-button>
            <el-button @click="updateFunc" type="success" size="mini" v-show="pageType==3">修 改</el-button>
        </span>

        <advertisingSituation ref="advertisingSituation" @close-callback="closeCllback"></advertisingSituation>
    </el-dialog>
</template>
<script>
    import * as api from '@/api/advAnalys/advAnalys.js'
    import advertisingSituation from './advertisingSituation'
    import addKeyWord from './addKeyWord'
    import {downloadFileUrl} from '@/utils/method'
    import {low_price_mall_operating_update_field} from '@/api/advAnalys/advAnalys.js'

    export default {
        components: {advertisingSituation, addKeyWord},
        data() {
            return {
                vineStatusArr: [
                    {name: '未申请', value: '未申请'},
                    {name: '申请中', value: '申请中'},
                    {name: '完成', value: '完成'},
                    {name: '老品', value: '老品'},
                ],
                standardProductTypeArr: [
                    {name: '标品-大众', value: '标品-大众'},
                    {name: '标品-小众', value: '标品-小众'},
                    {name: '非标-大众', value: '非标-大众'},
                    {name: '非标-小众', value: '非标-小众'},
                ],
                collateArr: [
                    {name: '已核对', value: 1},
                    {name: '未核对', value: 0},
                ],
                isLowPrice: [
                    {name: '是', value: 1},
                    {name: '否', value: 0},
                ],

                expands: [],
                pageType: 1, // 1add 2preview 3update
                editSubIndex: 0,
                prodIndex: 0,
                rules: {
                    reference_id: [
                        {
                            required: true,
                            message: '请输入Reference ID',
                            trigger: 'blur'
                        },
                    ],
                },
                dialogVisible: false,
                isPreview: false,
                formData: {},
                previewInfo: {},
            }
        },
        methods: {
            downFile(path) {
                if (!path) {
                    return this.$message({
                        type: 'error',
                        message: '无法下载！'
                    })
                }
                downloadFileUrl(path)
            },
            getRowKeys(row) {
                return JSON.stringify(row)
            },
            clickRowHandle(row, expanded) {
                const tempItem = JSON.stringify(row)
                if (this.expands.includes(tempItem)) {
                    this.expands = this.expands.filter(val => val !== tempItem)
                } else {
                    this.expands.push(tempItem)
                }
            },
            openModal(type, data) {
                this.pageType = type
                this.formData = data
                this.dialogVisible = true
            },
            closeCllback(obj) {
                if (obj.flag) {
                    let res = Object.assign(this.formData, obj.tempObj)
                    this.$set(this, 'formData', res)
                }
            },
            // 关闭弹窗
            handleClose(flag = false) {
                console.log('---close dialog')
                this.$set(this, 'dialogVisible', false)
                this.dialogVisible = false
                console.log(this.dialogVisible)
                this.isPreview = false
                this.initFormData()
                this.$emit('close-callback', true)
            },
            openAdvertisingSituation() {
                this.$refs.advertisingSituation.openModal(JSON.parse(JSON.stringify(this.formData)))
            },
            updateFunc() {
                this.$refs['formData'].validate(valid => {
                    if (valid) {
                        let tempFormData = JSON.parse(JSON.stringify(this.formData))
                        api.low_price_mall_operating_update_field(tempFormData).then(res => {
                            this.loading = false
                            if (res.code === 0) {
                                this.$message({message: '修改成功', type: 'success'})
                                this.handleClose(true)
                            } else {
                                this.$message({type: 'error', message: res.message})
                            }
                        }).catch(() => {
                            this.loading = false
                            this.$message({
                                type: 'error',
                                message: '网络出现问题，请刷新页面！'
                            })
                        })
                    } else {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '请填写相应内容！'
                        })
                    }
                })
            },
            initFormData() {
                this.formData = {}
            }
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .el-table .success-row {
        background: #f0f9eb;
    }

    .createDiv {
        float: right;
        width: 120px;
        height: auto;
        margin-top: 30px;

        .autoBtn {
            margin-bottom: 10px;
        }

        .autoBtn, .skagBtn {
            float: right;
        }
    }

    .wrapBox {
        display: flex;
        flex-wrap: wrap;
        width: 1300px !important;

        .boxItem {
            width: 400px;
            box-shadow: inset 0px 1px 1px white, 0px 1px 3px rgba(0, 0, 0, 0.5);
            margin-right: 10px;
            padding: 10px;
            border-radius: 10px;

            .tagBox {
                height: 300px;
                overflow: auto;
            }
        }
    }
</style>

